import { Link } from 'react-router-dom';

const Footer = ({ 
  useBrandColors = false, 
  appName = null, 
  companyName = null, 
  showPoweredBy = true,
  privacyPolicyUrl = null,
  termsUrl = null
}) => {
  const currentYear = new Date().getFullYear();
  
  // Determine the names to display
  const displayAppName = appName || 'UnCloned® Journal';
  const displayCompanyName = companyName || 'UnCloned® Media';
  
  // Use custom URLs if provided, otherwise default to internal routes
  const privacyLink = privacyPolicyUrl || '/privacy';
  const termsLink = termsUrl || '/terms';
  const isExternalPrivacy = privacyPolicyUrl && privacyPolicyUrl.startsWith('http');
  const isExternalTerms = termsUrl && termsUrl.startsWith('http');
  
  // Brand colors for login/public pages (UnCloned branding)
  const brandColors = {
    border: 'rgba(223, 18, 131, 0.2)',
    text: '#FDF2F8',
    gradientText: 'linear-gradient(90deg, #df1283, #FF7901)',
    secondary: '#df1283',
    textSecondary: 'rgba(253, 242, 248, 0.6)',
    link: '#0FFFE2'
  };
  
  return (
    <footer 
      className="w-full py-8 mt-8 flex items-center justify-center"
      style={{ 
        borderTop: useBrandColors 
          ? `1px solid ${brandColors.border}` 
          : '1px solid rgba(var(--theme-border-rgb, var(--theme-primary-rgb)), 0.2)' 
      }}
    >
      <div className="text-center">
        {/* Only show "is a product of" line if showPoweredBy is true */}
        {showPoweredBy && (
          <p className="text-sm mb-2" style={{ color: useBrandColors ? brandColors.text : 'var(--theme-text)', opacity: 0.8 }}>
            <span 
              className="font-semibold"
              style={useBrandColors 
                ? { background: brandColors.gradientText, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }
                : { color: 'var(--theme-primary)' }
              }
            >
              {displayAppName}
            </span> is a product of{" "}
            <span className="font-bold" style={{ color: useBrandColors ? brandColors.secondary : 'var(--theme-primary)' }}>{displayCompanyName}</span>
          </p>
        )}
        <div className="flex items-center justify-center gap-4 mb-2">
          {isExternalPrivacy ? (
            <a 
              href={privacyLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs hover:underline transition-colors"
              style={{ color: useBrandColors ? brandColors.link : 'var(--theme-accent, var(--theme-primary))' }}
            >
              Privacy Policy
            </a>
          ) : (
            <Link 
              to={privacyLink}
              className="text-xs hover:underline transition-colors"
              style={{ color: useBrandColors ? brandColors.link : 'var(--theme-accent, var(--theme-primary))' }}
            >
              Privacy Policy
            </Link>
          )}
          <span style={{ color: useBrandColors ? brandColors.textSecondary : 'var(--theme-text-secondary)' }}>•</span>
          {isExternalTerms ? (
            <a 
              href={termsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs hover:underline transition-colors"
              style={{ color: useBrandColors ? brandColors.link : 'var(--theme-accent, var(--theme-primary))' }}
            >
              Terms of Service
            </a>
          ) : (
            <Link 
              to={termsLink}
              className="text-xs hover:underline transition-colors"
              style={{ color: useBrandColors ? brandColors.link : 'var(--theme-accent, var(--theme-primary))' }}
            >
              Terms of Service
            </Link>
          )}
        </div>
        <p className="text-xs" style={{ color: useBrandColors ? brandColors.textSecondary : 'var(--theme-text-secondary)' }}>
          © {currentYear} {displayCompanyName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
